import { useRecordContext } from "react-admin";
import ApproveModal from "components/CareerCenter/Partials/ApproveModal";
import { careerCenterRequests } from "api/careerCenterApi";

const ApproveEmployer = () => {
  const record = useRecordContext();

  return (
    <ApproveModal
      title="Одобри"
      titleContent="Сигурен ли сте, че искате да одобрите този профил на работодател?"
      request={careerCenterRequests.activateEmployerProfile(record?.id)}
      successMessage="Успешно одобрен профил"
    />
  );
};

export default ApproveEmployer;
